import axios from 'axios'

const API_URL = `${process.env.REACT_APP_DB_HTTP}://${process.env.REACT_APP_DB_HOST}${process.env.REACT_APP_DB_PORT}`

/* Utility Functions */

export function getRecordingUrl(recordingName) {
  return `${API_URL}/media/audio/${recordingName}`
}
export function getAlbumUrl(bodyMakeId, bodyId) {
  return `${API_URL}/media/album/${bodyMakeId}-${bodyId}`
}

export function getDateStr(timestamp) {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const dateStr = `${year}-${month}-${day}`
  return dateStr
}

export function getDateTimeStr(timestamp) {
  if (!timestamp) return ''
  const dateTimeStr = `${getDateStr(timestamp)} ${getTimeStr(timestamp)}`
  return dateTimeStr
}

export function getTimeStr(timestamp) {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  const hour = String(date.getHours()).padStart(2, '0')
  const minute = String(date.getMinutes()).padStart(2, '0')
  const timeStr = `${hour}:${minute}`
  return timeStr
}

export function getTimeNow() {
  return new Date().getTime()
}

/* API Functions */

// Recordings
export function getRecording({ queryKey }) {
  const [, name] = queryKey
  return axios.get(`${API_URL}/audio/recording/${name}`).then((res) => res.data)
}
export function getRecordingList() {
  return axios.get(`${API_URL}/audio/recording`).then((res) => res.data)
}
export function getPlaylistRecordingList({ queryKey }) {
  const [, playlist] = queryKey
  return axios
    .get(`${API_URL}/audio/recording/playlist/${playlist}`)
    .then((res) => res.data)
}
export function getChassisRecordingList({ queryKey }) {
  const [, make, chassis] = queryKey
  return axios
    .get(`${API_URL}/audio/recording/chassis/${make}/${chassis}`)
    .then((res) => res.data)
}
export function getChassisInfo({ queryKey }) {
  const [, make, model] = queryKey
  return axios
    .get(`${API_URL}/audio/chassis/${make}/${model}`)
    .then((res) => res.data)
}
